import s from "styled-components";
import Paper from "_c/Paper";

export const Article = s(Paper)`
  > * {
    background-color: transparent !important;
  }
  p, blockquote {
    color: var(--font-color-main);
  }
  img {
    max-width: 100%;
    height: auto;
  }
`;
export const Controls = s.div`
  margin-top: 15px;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  button:first-child {
    margin-right: 15px;
  }
  @media(max-width: 991px) {
    margin-bottom: 25px;  
  }
`;
